<template>
    <b-form-select v-model="orderLocation" :options="locationOptions" @change="updateLocation" style="width: auto;">
        <template #first>
            <b-form-select-option :value="null" disabled>Location</b-form-select-option>
        </template>
    </b-form-select>
</template>

<script>
    import locationOptions from "../../assets/locationOptions";

    const REFUNDED_LOCATIONS = [
        'Lost In Mail (refunded)',
        'Not As Described Grade (refunded)',
        'Not As Described Pressing (refunded)',
    ];

    export default {
        name: "OrderLocation",
        mixins: [ locationOptions ],
        props: [ 'location', 'printView' ],
        data() {
            return {
                orderLocation: null,
            }
        },
        created() {
            if (this.location) {
                this.orderLocation = this.location;
            }
        },
        methods: {
            updateLocation() {
                const value = this.orderLocation;
                this.$emit('update', value);
                this.$emit('save', value);
                if (REFUNDED_LOCATIONS.includes(value)) {
                    this.$emit('promptRefundIfNeeded');
                }
            }
        }
    }
</script>

<style scoped>

</style>